module.exports = __webpack_public_path__ + "static/media/Heebo-Light.6d650807.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avesco/Heebo-Light.woff2
// module id = 779
// module chunks = 0